import React, {Component} from 'react';
import { responsiveFontSize, responsiveHeight } from '../Services/Utilities';
import LatexViewComponent2 from './LatexViewComponent2';

class RenderLatexAnswer extends Component {
    constructor(props){
        super(props)

    }

    render(){
        return(
            <div style = {{width:'100%', height:'100%',
            flexDirection:'row', display:'flex', alignContent:'center', alignItems:'center'}}>
                <LatexViewComponent2
                    text = {
                        (this.props.magnifier ? ('\\'+this.props.magnifier + '{'): '') 
                        +
                        this.props.answer.AnswerElements.sort((c,d) => c.Id > d.Id ? 1 : -1).reduce((a,b) => a += ' ' + (b.TextPresentation || (b.Value == '*' ? '\\cdot': b.Value)), '')
                        +
                        (this.props.magnifier ? ('}'): '') 
                    }
                    NoBorder
                />
            </div>
                
        )
    }
}

export default RenderLatexAnswer